import Reveal from "./Reveal";
import { scrollToId } from "@/hooks/useRevealObserver";

const quotes = [
  { text: "每天中午点开看一眼热榜，已经成了我和室友的固定仪式。", who: "追更三年的老粉" },
  { text: "把图书馆占座、食堂上新这些身边事讲得既清楚又有趣，点赞。", who: "某理工大学同学" },
  { text: "最难得是始终提醒大家保护隐私、理性围观，这分寸感我很喜欢。", who: "校园社群运营" },
];

const principles = [
  "聚焦现象，不对个体点名",
  "热点先核实，克制不夸大",
  "尊重隐私，守住边界",
  "轻松围观，理性表达",
];

const contactEmail = "hello@guatian.example.com";

export default function About() {
  return (
    <section id="about" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <div className="overflow-hidden rounded-[2rem] bg-gradient-to-br from-primary-600 via-primary-600 to-primary-700 text-background-50">
            <div className="grid gap-10 p-6 md:p-10 lg:grid-cols-2 lg:gap-14 lg:p-14">
              {/* 左：品牌介绍 */}
              <div className="flex flex-col items-start gap-5">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3.5 py-1.5 text-xs font-semibold text-accent-100 ring-1 ring-background-50/20 whitespace-nowrap">
                  <i className="ri-heart-3-fill text-sm" />
                  关于我们
                </span>
                <h2 className="text-2xl font-bold leading-tight md:text-4xl">
                  把校园里值得聊的事，
                  <br />
                  认真又轻松地讲给你听
                </h2>
                <p className="text-sm leading-relaxed text-background-50/85 md:text-base">
                  校园瓜田诞生于一个朴素的想法：校园里值得被看见和讨论的新鲜事那么多，却常常散落在不同角落里。我们想做一块清爽的"瓜田"，把这些热议按主题整理成可读的热榜与头条，让每一位想围观的你，几分钟就能跟上进度。
                </p>

                <div className="flex flex-wrap gap-2">
                  {principles.map((p) => (
                    <span key={p} className="inline-flex items-center gap-1.5 rounded-full bg-background-50/12 px-3.5 py-1.5 text-xs font-medium text-background-50 ring-1 ring-background-50/20 whitespace-nowrap">
                      <i className="ri-checkbox-circle-line text-sm text-accent-200" />
                      {p}
                    </span>
                  ))}
                </div>

                <div className="mt-1 flex flex-col gap-3 sm:flex-row sm:items-center">
                  <a
                    href={`mailto:${contactEmail}`}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-accent-100 whitespace-nowrap"
                  >
                    <i className="ri-send-plane-line text-lg" />
                    投稿 &amp; 联系我们
                  </a>
                  <button
                    type="button"
                    onClick={() => scrollToId("faq")}
                    className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold text-background-50 ring-1 ring-background-50/40 transition-colors hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
                  >
                    查看吃瓜指南
                  </button>
                </div>
              </div>

              {/* 右：口碑 + 联系方式 */}
              <div className="flex flex-col justify-between gap-8">
                <div className="grid gap-3 sm:grid-cols-1">
                  {quotes.map((q) => (
                    <figure key={q.who} className="rounded-2xl bg-background-50/12 p-4 ring-1 ring-background-50/15">
                      <i className="ri-double-quotes-l text-xl text-accent-200" />
                      <blockquote className="mt-1 text-sm leading-relaxed text-background-50/90">{q.text}</blockquote>
                      <figcaption className="mt-2 text-xs text-background-50/70">{q.who}</figcaption>
                    </figure>
                  ))}
                </div>

                <div className="flex items-center gap-4 rounded-2xl bg-background-50/15 p-5 ring-1 ring-background-50/20">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-accent-200/90 text-accent-800">
                    <i className="ri-mail-send-line text-xl" />
                  </span>
                  <div className="min-w-0">
                    <p className="text-xs text-background-50/75">投稿、建议与合作请发邮件</p>
                    <a href={`mailto:${contactEmail}`} className="block truncate text-sm font-bold text-background-50 underline decoration-background-50/40 underline-offset-4">
                      {contactEmail}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}